 $(document).on('click', 'a:not(.header-link[href="#newsletter-section"])', function (e) {
    if ($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0) {
      e.preventDefault();
 $('.mobile-menu-close').trigger('click');
      $('.slide-menu.menu-close-icon.mobile-menu-close.alt-focus').trigger('click');
      $('html').removeClass('slideout-open');
      if ($('.site-header').hasClass('fixed-header')) {
        var scrolltop = $($(this).attr('href')).offset().top - $('.site-header').height() - $('.about-navigation').height() + 1;
      } else {
        var scrolltop = $($(this).attr('href')).offset().top - 180;
      }
      
      $('html, body').animate({
        scrollTop: scrolltop
      }, 300);
      
      return false;
    }
  });

$('.Sign.Up').on('click', function(e) {
      e.preventDefault();
      
      //hideNav();
    $('.mobile-menu-close').trigger('click');
      $('.slide-menu.menu-close-icon.mobile-menu-close.alt-focus').trigger('click');
  $('html').removeClass('slideout-open');
      $('html, body').animate({
        scrollTop: $('#newsletter-section').offset().top - $('.header-wrapper').height()
      }, 1000);
    })